<template>
  <article class="voice-advice__create iv-p-t-24 iv-p-b-40">
    <div class="iv-main-width">
      <!--步骤看板-->
       <ApplyStep :stepData="stepData" />
      <!-- <BulletinBoard style="height: 180px;" v-for="(item, index) in boardList" :key="index" :data="item"></BulletinBoard> -->
      <VoicePanel title="心声建议"></VoicePanel>
      <FormLayout 
        ref="FormLayout"
        :readOnly="true"
        :model="personAdviceModel" 
        :list="personAdviceFormOptions">
      </FormLayout>
      <LayoutTitle title="附件信息">
        <FormLayout
          ref="FormLayout"
          :readOnly="true"
          :model="attachmentModel"
          :list="attachmentOptions">
        </FormLayout>
      </LayoutTitle>
      <LayoutTitle title="心声建议处理">
        <FormLayout
          ref="attachmentInfo" 
          :readOnly="isView"
          :model="theSecondAttachmentModel"
          :list="theSecondAttachmentOptions">
        </FormLayout>
      </LayoutTitle>
      <DragTable
        class="iv-m-t-24 iv-p-b-40"
        noUrl
        noSearch
        :showEdit="false"
        :showDelete="false"
        :showSelect="false" 
        :showPage="false"
        ref="DragTable" 
        :immediateForce="true" 
        :columns="columns" 
        :tableData="tableData">
      </DragTable>
      <FooterOperator>
        <div class="iv-text-center">
          <Button v-if="!isView" class="iv-m-r-8" type="submit" @click="handleSubmit">
            <span>提交处理结果</span>
          </Button>
          <Button v-if="!isView" class="iv-m-r-8" type="cancel" @click="handleBack">
            <span>退回</span>
          </Button>
          <Button type="back" @click="handleClickBack">
            <span>返回</span>
          </Button>
        </div>
      </FooterOperator>
    </div>
  </article>
</template>

<script>
import VoicePanel from '../components/panel.vue'
import formOptions, { attachmentOptions, theSecondAttachmentOptions } from './formOptions'
import FormLayout from '@/components/layout/form'
import LayoutTitle from '@/components/layout/layout-title'
import FooterOperator from '@/components/footer-operator'
import DragTable from '@/components/drag-table-inline'
import BulletinBoard from '@/components/bulletin-board-list'
import columns from './columns'
import { timeFormat } from '@/utils'
import ApplyStep from '../components/apply-step.vue'
export default {
  name: 'createVoiceAdvice',
  components: { 
    ApplyStep,
    DragTable,
    VoicePanel, 
    FormLayout, 
    LayoutTitle, 
    FooterOperator,
    BulletinBoard
  },
  data () {
    return {
      personAdviceFormOptions: [],
      personAdviceModel: {},
      attachmentOptions: [],
      attachmentModel: {},
      theSecondAttachmentOptions: [],
      theSecondAttachmentModel: {},
      getTypeCodesOptionList: [],
      handleTimes: timeFormat(new Date(), 'yyyy-MM-dd'),
      handleUserName: sessionStorage.getItem('userName'),
      handleOrgName: sessionStorage.getItem('fullName'),
      handleId: '',
      voiceAdviceId: this.$route.query.voiceAdviceId || '',
      groupId: '',
      groupId1: '',
      tableData: [],
      columns: [],
      stepData: [
        {
          step: 1,
          status: 'complete',
          title: '心声建议提交'
        },
        {
          step: 2,
          status: 'complete',
          title: '心声建议接收'
        },
        {
          step: 3,
          status: 'auditing',
          title: '心声建议处理'
        },
        {
          step: 4,
          status: 'wait',
          title: '处理结果审核'
        },
        {
          step: 5,
          status: 'wait',
          title: '心声建议反馈'
        }
      ]
    }
  },
  async created () {
    this.isView = this.$route.query.view == 'see'
    this.groupId1 = this.getUuid()
    Promise.all([this.getVoiceAdvice()]).then((params) => {
      Promise.all([this.getHandleInfo()]).then((...params) => {
        this.getList()
      })
    })
    Promise.all([this.getTypeCodesList()]).then((params) => {
    })
    this.getlistAudit()
    this.columns = columns.call(this)
  },
  methods: {
    getList() {
      this.personAdviceFormOptions = formOptions.call(this)
      this.attachmentOptions = attachmentOptions.call(this)
      this.theSecondAttachmentOptions = theSecondAttachmentOptions.call(this)
    },
    isLeaderAduit () {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/voiceAdvice/isLeaderAduit',
          method: 'GET',
          data: {
            voiceAdviceId: this.voiceAdviceId
          }
        }).then(data => {
          let res = data.data.data
          resolve(res)
        })
      }) 
    },
    // 查询心声建议详情
    getVoiceAdvice () {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url :'api-general/module/portal/voiceAdvice/get',
          method: 'GET',
          data: {
            voiceAdviceId: this.voiceAdviceId
          }
        }).then(data => {
          let res = data.data.data
          this.personAdviceModel = res
          this.personAdviceModel.adviceTime = timeFormat(this.personAdviceModel.adviceTime)
          this.theSecondAttachmentModel.handleOrgName = res.orgName
          this.theSecondAttachmentModel.handleUserName = res.userName
          this.theSecondAttachmentModel.handleTimes = this.handleTimes
          this.groupId = this.personAdviceModel.fileInfo || this.getUuid()
          this.getActivityFiles(this.groupId)
          resolve(res)
        })
      })
      
    },
    // 获取附件id 第一次上传附件 本地生产uuid
    getUuid () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    getActivityFiles (groupId) {
      this.$ajax({
        url: 'api-uum/file/listFilesByGroupId',
        method: 'GET',
        data: {
          isPage: false,
          groupId: groupId
        }
      }).then(({data}) => {
        this.$set(this.attachmentModel, 'fileInfo', data.data)
      })
    },
    getTypeCodesList() {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/user/outGetList',
          method: 'GET',
          data: {
            dictCode: 'GG68',
            merge: false,
            bizLineCode: 'YWX03'
          }
        }).then(res => {
          res.data.data.forEach(item => {
            this.getTypeCodesOptionList.push({
              label: item.title,
              value: item.value
            })
          })
          resolve()
        })
      })
    },
    // 办理过程查询
    getlistAudit () {
      this.$ajax({
        url: 'api-general/module/portal/voiceAdvice/listAudit',
        method: 'GET',
        data: {
          voiceAdviceId: this.voiceAdviceId
        }
      }).then(data => {
        let res = data.data.data
        this.tableData = res
      })
    },
    // 心声建议处理信息获取
    getHandleInfo( ) {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/voiceAdvice/getHandleInfo',
          method: 'GET',
          data: {
            voiceAdviceId: this.voiceAdviceId
          }
        }).then(data => {
          let res = data.data.data
          this.handleId = res.handleId
          this.theSecondAttachmentModel.handleOrgName = res.orgName
          resolve(res)
        })
      })
    },
    // 提交
    handleSubmit () {
      this.$refs.attachmentInfo.validate((validate) => {
        if(!validate) return this.$Message.error('有必填项未填写')
        this.$ajax({
          url: 'api-general/module/portal/voiceAdvice/handle',
          method: 'PUT',
          data: {
            voiceAdviceId: this.voiceAdviceId,
            processContent: this.theSecondAttachmentModel.processContent,
            fileId: this.groupId1,
            handleId: this.handleId,
            isSubmit: 'yes'
          }
        }).then(({data}) => {
          this.$Message.success('处理成功')
          this.$router.push({
            name: 'dealtList',
            query: {
              currentPage: this.$route.query.currentPage || 1,
              tabName: this.$route.query.tabName || ''
            }
          })
        })
      })
    },
    handleClickBack () {
      this.$router.push({
        name: 'dealtList',
        query: {
          currentPage: this.$route.query.currentPage || 1,
          voiceCurrentPage: this.$route.query.voiceCurrentPage || 1,
          tabName: this.$route.query.tabName || ''
        }
      })
    },
    handleBack() {
      this.$ajax({
        url: 'api-general/module/portal/voiceAdvice/sendBack',
        method: 'PUT',
        data: {
          voiceAdviceId: this.voiceAdviceId
        }
      }).then(data => {
        this.$Message.success('退回成功')
        this.$router.push({
          name: 'dealtList',
          query: {
            currentPage: this.$route.query.currentPage || 1,
            voiceCurrentPage: this.$route.query.voiceCurrentPage || 1,
            tabName: this.$route.query.tabName || ''
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.voice-advice__create {
  min-height: 100%;
  background-color: #fff;
}
</style>